"use strict";
import { __exports as r } from "./index.es494.js";
var u;
function D() {
  return u ? r : (u = 1, (function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return f;
      }
    });
    function f(n, s, e) {
      if (n) {
        e && (e = e.toLowerCase());
        for (const o of n) {
          var i, a;
          const c = (i = o.domain) == null ? void 0 : i.split(":", 1)[0].toLowerCase();
          if (s === c || e === o.defaultLocale.toLowerCase() || (a = o.locales) != null && a.some((l) => l.toLowerCase() === e))
            return o;
        }
      }
    }
  })(r), r);
}
export {
  D as __require
};
//# sourceMappingURL=index.es465.js.map
